import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import VinWonderTicketList from './VinWonderTicketList';
import { Link } from 'react-router-dom';

let permisionActions = [];

export default class VinWonderTickets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                vinWonderId: this.props.match.params.vin_wonder_id,
                pageSize: this.props.vinWonderTicketState.pageSize,
                pageIndex: this.props.vinWonderTicketState.pageIndex,
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.VIN_WONDER_TICKET);
        this.props.getListVinWonderTickets(this.state.filters);
    }

    render() {
        const {t, match} = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, vinWonderTickets } = this.props.vinWonderTicketState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'vinWonderTickets'}
                        titleHeader={t('navigation.vinWonderTickets')}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={Func.getPathWithParams(PATHS.VIN_WONDER_TICKET.CREATE.path, { vin_wonder_id: match.params.vin_wonder_id })}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <VinWonderTicketList loading={isFetching}
                                  permisions={permisionActions}
                                  vinWonderTickets={vinWonderTickets}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  vinWonderId={match.params.vin_wonder_id}
                                  onDelete={this.onDeleteVinWonderTicket}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.vin_wonder_id) {
            const path = Func.getPathWithParams(PATHS.VIN_WONDER.DETAIL.path, { id: match.params.vin_wonder_id })
            this.props.history.push(path);
        }
    }

    onChangeLanguage = () => {
        this.props.getListVinWonderTickets(this.state.filters)
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListVinWonderTickets(newFilters);
    }

    onDeleteVinWonderTicket = (item) => {
        this.props.deleteVinWonderTicketDetail(item, {
            filters: {
                pageSize: this.props.vinWonderTicketState.pageSize,
                pageIndex: this.props.vinWonderTicketState.pageIndex
            }
        });
    }
}

